(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltRestoreController', OltRestoreController);

    OltRestoreController.$inject = ['$scope', 'OltService', '$uibModalInstance', 'OltData'];

    function OltRestoreController($scope, OltService, $uibModalInstance, OltData) {

        var vm = this;

        vm.data = OltData;
        vm.backupList = [];
        vm.selectedBackup = null;

        OltService.getBackupOlt(vm.data.detail.id).then(successBackup).catch(errorBackup);

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        function successBackup(data) {
            vm.backupList = formatDate(data);
        }

        function errorBackup(response) {
            OltService.errorModalConstructor(response, 'getBackup');
        }

        vm.isSearchEmpty = function () {
            return !vm.backupList.length;
        }

        vm.restore = function () {
            var dataAction = {
                action: 'restore',
                methodService: 'restoreOltBackup'
            };
            var restoreData = {
                oltId: vm.data.detail.id,
                oltBackupId: vm.selectedBackup,
                name: vm.data.detail.name
            };
            OltService.confirmationOltModalConstructor([restoreData], dataAction);
        }

        function formatDate(data) {
            data.forEach(function (item) {
                item.creationDate = new Date(item.creationDate);
            });
            return data;
        }
    }
})();
